import { prop,propObject,propArray,required,maxLength,range  } from "@rxweb/reactive-form-validators"
import { gridColumn } from "@rxweb/grid"


export class UserTypeLookupBase {

//#region userType Prop
        @gridColumn({visible: true, columnIndex:0, allowSorting: true, headerKey: 'userType', keyColumn: false})
        userType : string;
//#endregion userType Prop


//#region applicationObjectId Prop
        @gridColumn({visible: true, columnIndex:1, allowSorting: true, headerKey: 'applicationObjectId', keyColumn: true})
        applicationObjectId : number;
//#endregion applicationObjectId Prop

}